import { IResource } from '../types';
import { useCalendarStoreSelector } from './useCalendarStoreSelector';
import { useMemo } from 'react';
import { findResource } from '../utils';

type UseResourceProps = {
	resourceId: number;
};

type UseResourceResult = {
	resource: IResource;
};

export const useResource = ({ resourceId }: UseResourceProps): UseResourceResult => {
	const resources: IResource[] = useCalendarStoreSelector(state => state.resources);

	const resource = useMemo(() => {
		return findResource(resources, resourceId)!;
	}, [resources, resourceId]);

	return {
		resource,
	};
};
